import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import AdminDashboard from "../Layout/AdminDashboard";
import { Spin, Button, message } from "antd";
import { ToWords } from "to-words";
import moment from "moment";
import UpdateGenerateInvoiceModal from "./UpdateGenerateInvoiceModal";
import signatoryImage from "../../assets/invoice_signature_image.png";
import toast from "react-hot-toast";

const ViewInvoice = () => {
  const { invoiceId } = useParams(); // Extract invoiceId from the route
  const [invoiceData, setInvoiceData] = useState(null);
  const [zoom, setZoom] = useState(1); // State to manage zoom level
  const [noteContent, setNoteContent] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [proposalId, setProposalId] = useState();
  const [companyProfile, setCompanyProfile] = useState(null);
  const [bankDetails, setBankDetails] = useState(null);
  const [proposalData, setProposalData] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const navigate = useNavigate();


  const [isAddressValid, setIsAddressValid] = useState(true);

  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchProposalData = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/proposal/getProposalById/${proposalId}`
      );
      // console.log(response, "proposal Data");

      const proposalData = response?.data;
      setProposalData(proposalData);
    } catch (error) {
      console.error("Error fetching proposal data:", error);
    }
  };

  useEffect(() => {
    if (proposalId) {
      fetchProposalData();
    }
  }, [proposalId]);

  const fetchInvoiceData = async () => {
    try {
      // Fetch invoice data, company details, and bank details concurrently
      const [invoiceResponse, companyResponse, bankDetailsResponse] =
        await Promise.all([
          axios.get(`${apiUrl}/api/invoice/getInvoiceById/${invoiceId}`),
          axios.get(`${apiUrl}/api/setting/getCompanyDetail`),
          axios.get(`${apiUrl}/api/setting/getTheBankDetails`),
        ]);

      // Log the full response to inspect the structure
      // console.log("Company Response:", companyResponse);

      // Extract the necessary data
      const invoiceData = invoiceResponse.data;
      const companyProfile1 = companyResponse.data?.profile; // Extract profile from company response
      const bankDetails = bankDetailsResponse.data?.bankDetail; // Extract bank details from bank response

      // console.log(invoiceResponse, "invoice Data");
      // console.log(companyProfile1, "company Profile");
      // console.log(bankDetails, "bank Details");
      const line2 = invoiceResponse?.data?.address?.line2?.trim();

      // Check whether Address Line 2 is valid
      const validAddress =
        line2 &&
        line2.includes(",") &&
        line2.split(",")[1]?.trim();

      setIsAddressValid(!!validAddress);

      if (!validAddress) {
        message.error(
          "Please complete the client address (City, State) in the Customer Form before viewing the invoice."
        );
      }
      // Set the states
      setProposalId(invoiceData.proposalId);
      // console.log("Proposal ID:", invoiceData.proposalId);
      setInvoiceData(invoiceData);
      setCompanyProfile(companyProfile1);
      setBankDetails(bankDetails);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  useEffect(() => {
    const fetchNoteContent = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/setting/getSetting`);
        // console.log("Fetched note content:", response.data);
        const formattedNote = response.data.invoice_note.split("\n");
        setNoteContent(formattedNote);
      } catch (error) {
        console.error("Error fetching note content:", error);
      }
    };

    fetchInvoiceData();
    // fetchProposalData();
    fetchNoteContent();
  }, [invoiceId]); // Depend on invoiceId only

  // Calculate total, cgst, sgst, and overall total only if invoiceData is available
  let subTotal = 0;
  let outletItems = "";

  if (invoiceData && invoiceData.outlets) {
    outletItems = invoiceData.outlets
      .map((outlet) => {
        const unit_cost = parseFloat(outlet.unit_cost || 0);
        const amount = parseFloat(outlet.amount || 0);

        subTotal += amount;

        return `
    <tr>
      <td class="px-2 py-1 border-b border-black text-center">${outlet.outlet_name || ""}</td>
      <td class="px-2 py-1 border border-black text-center">${outlet.description || ""}</td>
      <td class="px-2 py-1 border border-black text-center">${outlet.service || ""}</td>
      <td class="px-2 py-1 border border-black text-center">${outlet.man_days || 0}</td>
      <td class="px-2 py-1 border border-black text-center">${outlet.quantity || 0}</td>
      <td class="px-2 py-1 border border-black text-center">₹${unit_cost.toFixed(2)}</td>
      <td class="px-2 py-1 border-b border-black text-center">₹${amount.toFixed(2)}</td>
    </tr>
  `;
      })
      .join("");
  }
  // console.log("finance proposal data:", proposalData);
  // Add auditor convenience fee row if applicable
  // Auditor Fee Row
  const formatCurrency = (value) => {
    if (value === "N/A" || value === undefined || value === null) return "0.00";
    return Number(value).toFixed(2);
  };
  const numericAuditorFee = proposalData?.auditor_convenience_fee ?? 0;
  const auditorFee = formatCurrency(numericAuditorFee);
  const financialRows =
    numericAuditorFee !== 0
      ? ` <tr>
         <td class="px-2 py-1 border-l-0 border-black text-center">Others</td>
         <td class="px-2 py-1 border border-black text-center">Auditor Conveyance Charges</td>
         <td class="px-2 py-1 border border-black text-center">--</td>
         <td class="px-2 py-1 border border-black text-center">--</td>
         <td class="px-2 py-1 border border-black text-center">--</td>
         <td class="px-2 py-1 border border-black text-center">--</td>
        
         <td class="px-2 py-1 text-center currency-cell">${auditorFee}</td>
       </tr>`
      : ``;

  // console.log("Subtotal:", financialRows);

  const beforeTaxTotal = subTotal + parseFloat(auditorFee);

  const roundUpRupee = (value) => {
    if (!value) return 0;
    return Math.ceil(Number(value));
  };
  // Initialize tax variables
  let cgst = 0;
  let sgst = 0;
  let gst = 0;
  let igst = 0;
  let overallTotal = 0;
  // console.log("invoice data for tax", invoiceData.same_state);
  if (invoiceData && invoiceData.same_state) {
    cgst = parseFloat((beforeTaxTotal * 0.09).toFixed(2)); // 9% CGST
    sgst = parseFloat((beforeTaxTotal * 0.09).toFixed(2)); // 9% SGST
    overallTotal = roundUpRupee(parseFloat((beforeTaxTotal + cgst + sgst).toFixed(2)));
  } else {
    // gst = parseFloat((beforeTaxTotal * 0.18).toFixed(2)); // 18% GST
    igst = parseFloat((beforeTaxTotal * 0.18).toFixed(2)); // 18% IGST
    // sgst = parseFloat((beforeTaxTotal * 0.09).toFixed(2)); // 9% SGST
    overallTotal = roundUpRupee(parseFloat((beforeTaxTotal + igst + sgst).toFixed(2)));
  }

  // let tax;
  // if (invoiceData && invoiceData.same_state) {
  //   tax = `<p><span class="font-semibold">Add: CGST(9%):</span>${cgst}</p>
  //        <p><span class="font-semibold">Add: SGST(9%):</span>${sgst}</p>`;
  // } else {
  //   tax = `<p><span class="font-semibold">Add: IGST:</span>${gst}</p>`;
  // }
  let tax = invoiceData && invoiceData.same_state
    ? `
    <p style="border-bottom:1px solid black; padding:2px 6px;">₹0.00</p>
    <p style="border-bottom:1px solid black; padding:2px 6px;">₹${cgst.toFixed(
      2
    )}</p>
    <p style="padding:2px 6px;">₹${sgst.toFixed(2)}</p>
  `
    :
    //  `
    // <p style="border-bottom:1px solid black; padding:2px 6px;">₹${gst.toFixed(
    //   2
    // )}</p>
    // <p style="border-bottom:1px solid black; padding:2px 6px;">₹0.00</p>
    // <p style="padding:2px 6px;">₹0.00</p>
    // `
    `
    <p style="border-bottom:1px solid black; padding:2px 6px;">₹${igst.toFixed(
      2
    )}</p>
    <p style="border-bottom:1px solid black; padding:2px 6px;">₹0.00</p>
    <p style="padding:2px 6px;">₹${sgst.toFixed(2)}</p>
     `
    ;
  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        // can be used to override defaults for the selected locale
        name: "Rupee",
        plural: "Rupees",
        symbol: "₹",
        fractionalUnit: {
          name: "Paisa",
          plural: "Paise",
          symbol: "",
        },
      },
    },
  });

  let words = toWords.convert(overallTotal);

  const formattedDate = invoiceData
    ? moment(invoiceData.invoice_date).format("MMMM D, YYYY")
    : "";

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    fetchInvoiceData();
    setIsModalVisible(false);
  };

  if (!invoiceData) {
    return (
      <AdminDashboard>
        <div className="flex justify-center items-center h-screen">
          <Spin />
        </div>
      </AdminDashboard>
    );
  }
  // Download invoice file  
  const handleDownload = async () => {
    if (downloading) return;

    setDownloading(true);
    const toastId = toast.loading("Please wait, PDF downloading...");
    try {
      const response = await axios.post(
        `${apiUrl}/api/invoice/generateInvoice/${invoiceId}?download=true`,
        {},
        {
          responseType: "blob",
        }
      );

      // Create blob URL
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      // wait for loading 

      const url = window.URL.createObjectURL(blob);

      // Create temp anchor
      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoice_${invoiceData?.invoice_number || invoiceId}_${invoiceData?.fbo_name}.pdf`;

      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("PDF downloaded successfully", { id: toastId });
    } catch (error) {
      console.error(error);
      toast.error("Failed to download PDF", { id: toastId });
    } finally {
      setDownloading(false);
    }
  };
  const htmlTemplate = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Invoice</title>
  <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet" />
  <style>
    body {
      background-color: #ffffff;
      font-size: 11px;
    }
    .container {
      background-color: #ffffff;
      max-width: 100%;
      margin: auto;
      width: 793px;
      margin-left: auto;
      margin-right: auto;
    }
    table {
      border-collapse: collapse !important;
      font-size: 11px;
    }
    th {
      background-color: #edf2f7;
    }
    th,
    td {
      padding: 4px 6px;
    }
    .header-info,
    .bill-info,
    .total-info,
    .bank-info,
    .declaration,
    .signature {
      margin-bottom: 6px;
    }
    .header-info h2,
    .bill-info h2,
    .bank-info h2,
    .declaration h2 {
      font-size: 13px;
    }
    .text-right p {
      margin: 0;
    }
    .content-box {
      position: relative;
      background-image: linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url("/logo2.png");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center center;
    }
  </style>
</head>
<body class="p-4 bg-white m-4">
  <div class="container mx-auto mt-4  border border-black">
    <div class="header-info flex justify-between items-center border-b p-2 border-gray-400">
      <div>
        <h2 class="text-lg font-bold" style="color: #13A6B8;">
          ${companyProfile?.company_name?.toUpperCase() ||
    "UNAVAR FOOD INSPECTION AND CERTIFICATION PRIVATE LIMITED"
    }
        </h2>
        <p style="color: #13A6B8;">
          ${companyProfile?.company_address?.line1 || "Address Line 1"}, 
          ${companyProfile?.company_address?.line2 || "Address Line 2"}, 
          ${companyProfile?.company_address?.city || "City"}, 
          ${companyProfile?.company_address?.state || "State"} - 
          ${companyProfile?.company_address?.pincode || "Pincode"}
        </p>
        <p style="color: #13A6B8;">
          Tel: ${companyProfile?.contact_number || "Contact Number"} | Email: ${companyProfile?.email || "Email not available"
    }
        </p>
        <p style="color: #13A6B8;">
          GSTIN: ${companyProfile?.gstin || "GSTIN not available"} | PAN: ${companyProfile?.pan || "PAN not available"
    }
        </p>
      </div>
      <img src="/logo2.png" alt="Your Image Alt Text" width="80" height="80" />
    </div>
    <h2 class="text-md font-bold my-2 text-center text-gray-700">TAX INVOICE</h2>
    <div class="content-box">
      <table class="w-full text-sm table-fixed" style="border-left: none; border-right: none; border-top: 1px solid black; border-bottom: 1px solid black;">
        <tbody style="font-size: 11px;">
          <tr>
            <td class="border border-black px-2 py-1 font-semibold w-32 border-l-0">Invoice No:</td>
            <td class="border border-black px-2 py-1">${invoiceData.invoice_number
    }</td>
            <td class="border border-black px-2 py-1 font-semibold w-48" rowspan="2">Field Executive Name:</td>
            <td class="border border-black px-2 py-1 border-r-0" rowspan="2">${invoiceData.field_executive_name
    }</td>
          </tr>
          <tr>
            <td class="border border-black px-2 py-1 font-semibold border-l-0">Invoice Date:</td>
            <td class="border border-black px-2 py-1">${formattedDate}</td>
          </tr>
          <tr>
            <td class="border border-black px-2 py-1 font-semibold border-l-0">Order Ref No:</td>
            <td class="border border-black px-2 py-1">${invoiceData.proposal_number
    }</td>
            <td class="border border-black px-2 py-1 font-semibold" rowspan="2">Team Leader Name:</td>
            <td class="border border-black px-2 py-1 border-r-0" rowspan="2">${invoiceData.team_leader_name
    }</td>
          </tr>
          <tr>
            <td class="border border-black px-2 py-1 font-semibold border-l-0">Cust. P.O. No:</td>
            <td class="border border-black px-2 py-1">${invoiceData.po_number ?? ""
    }</td>
          </tr>
        </tbody>
      </table>
      <h2 class="text-md font-semibold text-gray-700 text-center py-1">Bill to Party</h2>
      <table class="w-full text-sm table-fixed" style="border-left: none; border-right: none; border-top: 1px solid black; border-bottom: 1px solid black;">
        <tbody style="font-size: 11px;">
          <tr>
            <td class="border border-black px-2 py-1 font-semibold border-l-0">Name:</td>
            <td colspan="5" class="border border-black px-2 py-1 border-r-0">${invoiceData.fbo_name
    }</td>
          </tr>
          <tr>
            <td class="border border-black px-2 py-1 font-semibold border-l-0">Address:</td>
            <td colspan="5" class="border border-black px-2 py-1 border-r-0">
              ${invoiceData.address.line1}${invoiceData.address.line2 ? `, ${invoiceData.address.line2}` : ""
    }
            </td>
          </tr>
          <tr>
            <td class="border border-black border-l-0 px-2 py-1 font-semibold">GSTIN:</td>
            <td class="border border-black px-2 py-1">${invoiceData.gst_number
    }</td>
            <td class="border border-black px-2 py-1 font-semibold">State (Place of Supply):</td>
            <td class="border border-black px-2 py-1">${invoiceData.place_of_supply
    }</td>
            <td class="border border-black px-2 py-1 font-semibold">Pincode Code:</td>
            <td class="border border-black px-2 py-1 border-r-0">${invoiceData.pincode
    }</td>
          </tr>
        </tbody>
      </table>
      <div class="flex justify-center py-1">
        <p><span class="font-semibold">SAC:</span> 998399 (18%)</p>
      </div>
      <table class="w-full text-sm table-fixed" style="border-left: none; border-right: none; border-top: 1px solid black; border-bottom: 1px solid black;">
        <tbody style="font-size: 11px;">
          <tr>
            <td class="px-2 py-1 border border-black text-center font-semibold border-l-0">Outlet Name</td>
            <td class="px-2 py-1 border border-black text-center font-semibold">Service</td>
            <td class="px-2 py-1 border border-black text-center font-semibold">Criteria</td>
            <td class="px-2 py-1 border border-black text-center font-semibold">Man Days</td>
            <td class="px-2 py-1 border border-black text-center font-semibold">Qty</td>
            <td class="px-2 py-1 border border-black text-center font-semibold">Unit Cost</td>
            <td class="px-2 py-1 border border-black text-center font-semibold border-r-0">Amount</td>
          </tr>
          ${outletItems}
          ${financialRows}
      

          <tr>
            <td class="px-2 py-1 border border-black font-semibold text-center border-l-0" colspan="5">Total Invoice amount in words:</td>
            <td class="px-2 py-1 border border-black font-semibold text-right">Sub Total</td>
            <td class="px-2 py-1 border border-black font-semibold text-center border-r-0">₹${beforeTaxTotal.toFixed(2)}</td>
          </tr>
     

          <tr>
              <td
                class="px-2 border border-black font-bold text-center border-l-0 capitalize"
                rowspan="2"
                colspan="5"
              >
                ${words}
              </td>
              <td
                class="border border-black font-bold text-left align-top px-0"
              >
                <p style="border-bottom: 1px solid black; padding: 2px 6px;text-align: center;">
                  Add: IGST
                </p>
                <p style="border-bottom: 1px solid black; padding: 2px 6px; text-align: center;">
                  Add: CGST
                </p>
                <p style="padding: 2px 6px;text-align: center;">Add: SGST</p>
              </td>
              <td
                class="border border-black font-bold text-center border-r-0 align-top px-0"
              >
                ${tax}
              </td>
            </tr>
          <tr>
            <td class="px-2 py-1 border border-black font-bold text-center">Total Amount after Tax:</td>
            <td class="px-2 py-1 border border-black font-bold text-center border-r-0">₹${overallTotal.toFixed(2)}</td>
          </tr>
          <tr>
            <td class="px-2 py-1 border border-black font-semibold text-left border-l-0" colspan="5" style="border-bottom: none;">Bank Account Details</td>
            <td class="px-2 py-1 border border-black font-semibold text-right" style="border-left: 1px solid black;">GST on Reverse Charge</td>
            <td class="px-2 py-1 border border-black font-semibold text-center border-r-0" style="border-left: 1px solid black;">${invoiceData.Gst ?? "0"
    }</td>
          </tr>
          <tr>
            <td colspan="2" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">Account Holder's Name:</td>
            <td colspan="3" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">${bankDetails?.account_holder_name || "Account Holder's Name"
    }</td>
            <td colspan="2" class="px-2 py-1 border border-black font-semibold text-left border-r-0" style="border-left: 1px solid black;">Certified that the particulars given above are true and correct</td>
          </tr>
          <tr>
            <td colspan="2" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">Bank Name:</td>
            <td colspan="3" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">${bankDetails?.bank_name || "Bank Name"
    }</td>
            <td colspan="2" rowspan="6" class="relative" style="border-left: 1px solid black;">
              <div class="flex flex-col justify-between absolute inset-0 p-1">
                <div class="text-center font-semibold">For UNAVAR Food Inspection & Certification Pvt Ltd</div>
                <img class="w-16 h-16 ml-20" src=${signatoryImage} alt="Signature" />
                <div class="text-center font-semibold">Authorised signatory</div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">Bank Branch:</td>
            <td colspan="3" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">${bankDetails?.branch_name || "Bank Branch"
    }</td>
          </tr>
          <tr>
            <td colspan="2" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">IFSC Code:</td>
            <td colspan="3" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">${bankDetails?.ifsc_code || "IFSC Code"
    }</td>
          </tr>
          <tr>
            <td colspan="2" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">MICR Code:</td>
            <td colspan="3" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">${bankDetails?.micr_code || "MICR Code"
    }</td>
          </tr>
          <tr>
            <td colspan="2" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">Account No:</td>
            <td colspan="3" class="px-2 py-1 border border-black font-semibold text-left" style="border: none;">${bankDetails?.account_number || "Account Number"
    }</td>
          </tr>
        </tbody>
      </table>

      <table class="w-full border  border-collapse text-sm">
  <tbody>
    <tr>
      <!-- Left side: Declaration -->
      <td class="align-top p-2 border-r border-black  w-2/3">
        <strong>Declaration:</strong>
        <br /><br />
        <p>1. E& O.E,</p>
        <p>2. Please Quote Invoice no while making payment,</p>
        <p>3. Invoice Payable within 7 days failing which interest @2% per month will be charged.</p>
        <br />
        <p><strong>Udyog Aadhar No. UDYAM-TN-02-0162170</strong></p>
        <p>
          Payment to be made as per our agreed terms. Delay in payment to us beyond
          45 days from the date of receipt of invoice would attract interest of
          24% p.a. as per MSMED Act, 2006.
        </p>
      </td>

      <!-- Right side: Authorized Signatory -->
      <td class="align-top p-2 border-l   text-center w-1/3">
        <p>
          <strong>Remark</strong><br />
          ${invoiceData.remark || "No remarks provided"}
        </p>
        <br /><br /><br />
        
      </td>
    </tr>
  </tbody>
</table>

     
    </div>
  </div>
</body>
</html>`;

  return (
    <AdminDashboard>
      <div className="top-0 z-50 bg-white">
        <div className="mb-10 border shadow-bottom px-4 py-4 flex items-center">
          <span
            onClick={() => navigate(-1)}
            className="cursor-pointer text-3xl mr-4"
          >
            ←
          </span>
          <h2 className="text-xl font-semibold">View Invoice Document</h2>
          <div className="flex ml-auto gap-x-4">
            <Button type="primary" className="ml-auto" disabled={!isAddressValid} onClick={showModal}>
              Edit
            </Button>
            <Button
              onClick={handleDownload}
              disabled={!isAddressValid || downloading}
              className={`px-4 py-2 rounded-md text-white transition-all
                ${!isAddressValid || downloading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
                }`}
            >
              {downloading ? "Downloading..." : "Download PDF"}
            </Button>
          </div>
        </div>
      </div>

      <>
        <div className="fixed bottom-4 right-4 flex items-center space-x-4 z-10">
          <button
            onClick={() => setZoom((prevZoom) => Math.max(prevZoom - 0.1, 0.5))}
            className="px-4 py-2 bg-gray-200 border border-gray-400 rounded"
          >
            -
          </button>
          <span className="text-lg">Zoom: {Math.round(zoom * 100)}%</span>
          <button
            onClick={() => setZoom((prevZoom) => Math.min(prevZoom + 0.1, 1.1))}
            className="px-4 py-2 bg-gray-200 border border-gray-400 rounded"
          >
            +
          </button>
        </div>

        <div className="flex justify-center">
          <div
            className=""
            style={{
              width: `${793 * zoom}px`, // Adjust width based on zoom
              transform: `scale(${zoom})`,
              transformOrigin: "center", // Center the zoom effect
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: htmlTemplate }} />
          </div>
        </div>
        <UpdateGenerateInvoiceModal
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          proposalId={proposalId}
          invoiceId={invoiceId}
        />
      </>
    </AdminDashboard>
  );
};

export default ViewInvoice;
